module.exports = __webpack_public_path__ + "static/media/process-automation.25b0c7fc.svg";